module.exports = __webpack_public_path__ + "img/dataIcon1.695ea893.svg";